import { observer } from 'mobx-react-lite'
import classNames from 'classnames'
import { Button, InputRadio } from 'shared/ui'
import { Label } from 'shared/ui/Label'
import { CrmSelectField } from 'entities/Integrations'
import { type RegisterStore } from 'pages/register/ui/Register'

import styles from './styles.module.scss'

type IFormProps = {
  store: RegisterStore
}

export const Step2Form = observer(({ store }: IFormProps) => {
  const {
    step2Store: { crm, setCrm, contactsCount, contactsCounts, setContactsCount, isNextDisabled },
    handleNextStep,
  } = store

  return (
    <div className={styles.wrap}>
      <CrmSelectField label={'Which CRM does your company use?'} value={crm} onChange={setCrm} />

      <Label
        label={{
          text: 'How many contacts do you have?',
          className: styles.inputLabel,
        }}
      />
      <div className={styles.wrapSizes}>
        {contactsCounts.map(({ id, label }) => (
          <InputRadio
            className={classNames(styles.inputSize, {
              [styles.active]: id === contactsCount,
            })}
            checked={id === contactsCount}
            onChecked={() => setContactsCount(id)}
            key={id}
            label={label}
          />
        ))}
      </div>
      <Button
        className={styles.button}
        typeBtn='contained'
        type='button'
        onClick={handleNextStep}
        disabled={isNextDisabled}
        text={'Next'}
        contained={'primary'}
        fullWidth
      />
    </div>
  )
})

export default Step2Form
